import {cn, cva} from 'platform/shared';

import type {ComponentPropsWithoutRef} from 'react';

const emojiPickerWrapperVariants = cva('relative inline-flex align-middle');

export function EmojiPickerWrapper(props: ComponentPropsWithoutRef<'span'>) {
  return <span {...props} className={cn(emojiPickerWrapperVariants(), props.className)} />;
}

const emojiPanelVariants = cva(
  'absolute top-[calc(100%+0.25rem)] left-0 z-10 w-56 rounded-[var(--radius-small)] border border-solid border-[var(--color-palettes-neutral-50-100)] bg-[var(--color-palettes-white-10-100)] p-2 [box-shadow:var(--shadow-active)]'
);

export function EmojiPanel(props: ComponentPropsWithoutRef<'div'>) {
  return <div {...props} className={cn(emojiPanelVariants(), props.className)} />;
}

const emojiCategoryTabsVariants = cva('flex flex-wrap gap-1 pb-2');

export function EmojiCategoryTabs(props: ComponentPropsWithoutRef<'div'>) {
  return <div {...props} className={cn(emojiCategoryTabsVariants(), props.className)} />;
}

export type EmojiCategoryButtonProps = ComponentPropsWithoutRef<'div'> & {
  $isActive: boolean;
};

const emojiCategoryButtonVariants = cva(
  'cursor-pointer select-none rounded-[var(--radius-small)] border border-solid px-2 py-1 text-[length:var(--text-size-x-small)]',
  {
    variants: {
      isActive: {
        true: 'border-[var(--color-general-accent)] bg-[var(--color-palettes-blue-20-100)]',
        false:
          'border-[var(--color-palettes-neutral-50-100)] bg-[var(--color-palettes-white-10-100)]',
      },
    },
  }
);

// Rendered as <div> rather than <button> so Quill's `.ql-snow .ql-toolbar button` rule
// (which forces width/height/float on every <button> inside the toolbar) doesn't reach
// these descendants of the toolbar wrapper.
export function EmojiCategoryButton(props: EmojiCategoryButtonProps) {
  const {$isActive, className, ...htmlProps} = props;

  return (
    <div
      {...htmlProps}
      className={cn(emojiCategoryButtonVariants({isActive: $isActive}), className)}
    />
  );
}

const emojiButtonVariants = cva(
  'cursor-pointer select-none rounded-[var(--radius-small)] border border-solid border-[var(--color-palettes-neutral-40-100)] bg-[var(--color-palettes-white-10-100)] p-1 text-center text-[length:var(--text-size-base)]'
);

export function EmojiButton(props: ComponentPropsWithoutRef<'div'>) {
  return <div {...props} className={cn(emojiButtonVariants(), props.className)} />;
}
